module.exports = __webpack_public_path__ + "static/img/bx2.0c35852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bx2.png
// module id = oUzC
// module chunks = 0